import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

export const marketingService = {
  // Send to a small list of test numbers — returns per-number results.
  test: (message: string, numbers: string[]) =>
    unwrap(auth().post('user/marketing/whatsapp/test', { message, numbers })),
  // Broadcast to existing users (optionally one product) — runs in background.
  broadcast: (message: string, product?: string) =>
    unwrap(auth().post('user/marketing/whatsapp/broadcast', { message, product: product || undefined })),
};
